import { TimeSlotPicker, TimeSlotPickerProps } from '@viveaesthetics/shared'

import { useGetProviderAvailableWindowByDay } from '@/hooks/provider/useGetProvidersAvailableWindowByDay'

const getUseGetPotentialAppointmentSlotsWithProviderId =
  (providerId: string) =>
  ({
    dateRange,
    withGranularSlots = false,
    enabled = true
  }: Parameters<TimeSlotPickerProps['useGetSlots']>[0]) => {
    const { data: providersTimeSlots, ...providerAvailableWindowByDayRest } =
      useGetProviderAvailableWindowByDay({
        providerId,
        dateRange,
        withGranularSlots,
        enabled: enabled && !!providerId
      })

    return {
      data: providersTimeSlots?.[providerId],
      ...providerAvailableWindowByDayRest
    }
  }

interface ProviderAppointmentTimeSlotPickerProps {
  onChange: (date: Date) => void
  value?: Date
  error?: string
  providerId: string
  variant?: TimeSlotPickerProps['variant']
}

export const ProviderAppointmentTimeSlotPicker = ({
  onChange,
  value,
  providerId,
  error,
  variant
}: ProviderAppointmentTimeSlotPickerProps) => {
  const useGetSlots =
    getUseGetPotentialAppointmentSlotsWithProviderId(providerId)

  const { timeZone } = Intl.DateTimeFormat().resolvedOptions()

  return (
    <TimeSlotPicker
      variant={variant}
      onChange={onChange}
      value={value}
      useGetSlots={useGetSlots}
      error={error}
      timeZone={timeZone}
    />
  )
}
